import classNames from './SkippedActivitiesModal.module.scss';
import classes from 'classnames';
import { useTranslation } from 'react-i18next';
import { Transition } from 'react-transition-group';

import TheButton from '@/components/TheButton/TheButton';
import AppBackdrop from '@/components/AppBackdrop';
import AppModal from '@/components/AppModal';

import backOnlineImg from '@/assets/svg/back-online.svg';

interface SkippedActivitiesModalProps {
  show: boolean;
  onRefresh: () => void;
  onStartSkippedActivities: () => void;
}

const SkippedActivitiesModal = ({
  show,
  onRefresh,
  onStartSkippedActivities,
}: SkippedActivitiesModalProps) => {
  const { t } = useTranslation();

  return (
    <Transition
      in={show}
      timeout={400}
      mountOnEnter
      unmountOnExit
      children={state => {
        return (
          <>
            <AppBackdrop className={classes(classNames.backdrop, `backdrop-${state}`)} />
            <AppModal className={classNames.appModal}>
              <div className={classes(classNames.modal, `fade-${state}`)}>
                <img src={backOnlineImg} />
                <h2>{t('backOnline')}</h2>
                <span
                  className={classNames.description}
                  dangerouslySetInnerHTML={{
                    __html: t('backOnlineActivities').toString(),
                  }}
                />
                <div className={classNames.bottom}>
                  <div className={classNames.buttons}>
                    <TheButton
                      className={classNames.cancelBtn}
                      text={t('backHome')}
                      plain
                      emitOnClick={onRefresh}
                    />
                    <TheButton
                      className={classNames.startBtn}
                      text={t('startSkippedActivities')}
                      emitOnClick={onStartSkippedActivities}
                      showArrow={true}
                    />
                  </div>
                </div>
              </div>
            </AppModal>
          </>
        );
      }}
    />
  );
};

export default SkippedActivitiesModal;
